import { useEffect, useState } from 'react';

const useIsMobileByNavigator = () => {
	const [state, setState] = useState(false);
	
	useEffect(() => {
		const esMobil = () => navigator.userAgent.match(/Android/i) ||
		navigator.userAgent.match(/iPad/i) ||
		navigator.userAgent.match(/webOs/i) ||
		navigator.userAgent.match(/iPod/i) ||
		navigator.userAgent.match(/iPhone/i) ||
		navigator.userAgent.match(/BlackBerry/i) ||
		navigator.userAgent.match(/Windows Phone/i);
		
		const mobil = esMobil();
		if(mobil) setState(true);

            return () => setState(false);
	},[]); // eslint-disable-line react-hooks/exhaustive-deps
	return state;
};

export default useIsMobileByNavigator;
